// extracted by mini-css-extract-plugin
export default {"MediaAsset":"MediaAsset-module__MediaAsset--UCBoW","Image":"MediaAsset-module__Image--K5ry9"};